import { encode as base64_encode } from "base-64";

import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class ServiceTemplateStore {
  loading = false;
  total = 0;
  mainServiceList = [];
  photoFromDb = {};

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      mainServiceList: observable,
      photoFromDb: observable,

      loadData: action,
      deleteRecord: action,
      addData: action,
      exportExcel: action,
      setPhotoFromDb: action,
      getServiceTempData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit }) {
    this.loading = true;
    const params = { offset, limit };
    const response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/ServiceType/getServiceData");
    this.mainServiceList = response?.data?.data;
    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async exportExcel(postData) {
    try {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/ServiceType/exportServiceExcel", postData, {
          responseType: "blob",
        });
      // console.log(response, "response");
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Service Report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }
  async addData(postData) {
    var serviceData = { postData };
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/ServiceType/saveServiceTemplate", serviceData);
    return response.data;
  }

  async setPhotoFromDb(photo) {
    // console.log(photo)
    this.photoFromDb = { fileList: photo };
  }

  async getServiceTempData(serviceId) {
    var queryParams = {
      serviceId: serviceId,
      limit: 1,
      offset: 0,
    };

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/ServiceType/getServiceData", {
        params: queryParams,
      });
    const singleRow = response?.data?.data[0];

    if (singleRow.logo) {
      const fileList = [
        {
          name: singleRow.logo,
          status: "success",
          url: config.fleetURL + "/images/drivers/" + singleRow.logo,
        },
      ];

      this.setPhotoFromDb(fileList);
    }
    return singleRow;
  }

  async deleteRecord({ serviceId }) {
    var response = await postApi
      .getClient("")
      .delete(config.NodeUrl + "/ServiceType/deleteServiceType", {
        params: {
          serviceId: serviceId,
        },
      });

    return response;
  }
}

export default ServiceTemplateStore;
